import { ProFormList, ProProvider } from '@ant-design/pro-components'
import { Form, Modal, Tooltip } from 'antd'
import Cookies from 'js-cookie'

export const ACCESS_TOEKN_KEY = 'access_token'

// 添加全局变量
export const NAME = 'aido'

export const setToken = (token: string) => {
  Cookies.set(ACCESS_TOEKN_KEY, token)
}

export const getToken = () => {
  return Cookies.get(ACCESS_TOEKN_KEY)
}

try {
  Modal.defaultProps = {
    okText: 'Confirm'
  }
  Tooltip.defaultProps = {
    color: '#fff'
  }
} catch (e) {
  console.error(e)
}
